module.exports = __webpack_public_path__ + "static/media/shop02.c827c715.png";